module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fm",
    attrs: {
      "id": "fm"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('em', [_vm._v("Rejoice, young man in your youth, and let your heart pleasure you in the days of your young manhood; and walk in the ways of your heart, and the sight of your eyes; but know that for all these God will bring you into judgment. So remove trouble from your heart and put away wrongdoing from your flesh, for boyhood and youth are a breath")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("ECCLESIASTES 11:9–10")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04650693","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0004.vue
// module id = 72
// module chunks = 0